import React, { useState } from "react";
import axios from "axios";
import { FaDownload } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";

const DownloadLogsComponent = () => {
	const [fromDateTransaction, setFromDateTransaction] = useState("");
	const [toDateTransaction, setToDateTransaction] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const handleDownloadZip = async () => {
		setIsLoading(true);
		setError("");

		try {
			const fromDateTime = new Date(fromDateTransaction);
			const toDateTime = new Date(toDateTransaction);

			if (!fromDateTransaction || !toDateTransaction) {
				setError("Please select both From and To dates.");
				setIsLoading(false);
				return;
			}

			if (toDateTime.getTime() < fromDateTime.getTime()) {
				setError("To date cannot be earlier than From date.");
				setIsLoading(false);
				return;
			}

			const formData = new FormData();
			formData.append("startDate", fromDateTransaction);
			formData.append("endDate", toDateTransaction);

			const { data } = await axios.post(
				"https://ecobank.approot.ng/dashboard/merge_zip_download.php",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
					responseType: "blob",
				}
			);

			if (!data) {
				setError("Failed to generate ZIP. Please try again later.");
				setIsLoading(false);
				return;
			}

			const blob = new Blob([data], { type: "application/zip" });
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = downloadUrl;
			link.setAttribute(
				"download",
				`merged_${fromDateTransaction}_${toDateTransaction}.zip`
			);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("Error downloading ZIP:", error);
			setError("An error occurred while downloading the ZIP file.");
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className='max-w-xl mx-auto p-8 rounded-xl bg-gradient-to-br from-white via-gray-50 to-gray-100 shadow-lg border border-gray-200 backdrop-blur-sm'>
			<h2 className='text-3xl font-bold mb-6 text-center text-blue-800'>
				📁 Download Logs
			</h2>

			<div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mb-6'>
				<div>
					<label className='block text-sm font-semibold text-gray-700 mb-2'>
						From Date
					</label>
					<input
						type='date'
						value={fromDateTransaction}
						onChange={(e) => setFromDateTransaction(e.target.value)}
						className='w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none text-sm'
					/>
				</div>

				<div>
					<label className='block text-sm font-semibold text-gray-700 mb-2'>
						To Date
					</label>
					<input
						type='date'
						value={toDateTransaction}
						onChange={(e) => setToDateTransaction(e.target.value)}
						className='w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none text-sm'
					/>
				</div>
			</div>

			{error && (
				<div className='mb-5 p-3 text-sm text-red-700 bg-red-100 rounded-md border border-red-300'>
					{error}
				</div>
			)}

			<button
				onClick={handleDownloadZip}
				disabled={isLoading}
				className={`w-full py-3 rounded-lg text-white font-semibold flex justify-center items-center gap-2 shadow-md transition ${
					isLoading
						? "bg-blue-400 cursor-not-allowed"
						: "bg-blue-600 hover:bg-blue-700"
				}`}
			>
				{isLoading ? (
					<>
						<ImSpinner2 className='animate-spin text-lg' />
						Downloading...
					</>
				) : (
					<>
						<FaDownload className='text-md' />
						Download ZIP
					</>
				)}
			</button>
		</div>
	);
};

export default DownloadLogsComponent;
